module.exports = __webpack_public_path__ + "static/media/blur_recipe_category_all.46f11f47.jpg";